/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import StringResources from 'nls/StringResources';

function getVisibility(cards) {
	return {
		allHidden: !cards.some(card => !card.isHidden),
		allVisible: !cards.some(card => card.isHidden)
	};
}

/**
 * Models the show card action
 */
class ShowAction {
	getAttributes() {
		return {
			id: 'show',
			//no icon yet - need to add one if this action is to appear in the toolbar
			label: StringResources.get('card_sidebar_show'),
			className: null
		};
	}

	isEnabled(cards) {
		const {
			allHidden, allVisible
		} = getVisibility(cards);
		return allHidden || !allVisible;
	}

	action(cards) {
		return cards.forEach(
			card => card.toggleHidden(false)
		);
	}
}

/**
 * Models the hide card action
 */
class HideAction {
	getAttributes() {
		return {
			id: 'hide',
			//no icon yet - need to add one if this action is to appear in the toolbar
			label: StringResources.get('card_sidebar_hide'),
			className: null
		};
	}

	isEnabled(cards) {
		const {
			allHidden, allVisible
		} = getVisibility(cards);
		return allVisible || !allHidden;
	}

	action(cards) {
		return cards.forEach(
			card => card.toggleHidden(true)
		);
	}
}

export {
	ShowAction,
	HideAction
};



// WEBPACK FOOTER //
// ./src/js/components/cards/actions/ShowHideActions.js